/** دسترسی به بخش AMI: نقش admin/superadmin یا پرچم داده‌شده توسط مدیر اصلی. */
export function canAccessAmi(): boolean {
  const r = (localStorage.getItem('admin_role') || '').trim().toLowerCase();
  if (r === 'admin' || r === 'superadmin') return true;
  return localStorage.getItem('admin_ami_access') === '1';
}

export function isMainAdmin(): boolean {
  const r = (localStorage.getItem('admin_role') || '').trim().toLowerCase();
  return r === 'admin' || r === 'superadmin';
}

export function setAmiAccessFromLogin(value: boolean | undefined | null): void {
  localStorage.setItem('admin_ami_access', value ? '1' : '0');
}

export function clearAmiAccess(): void {
  localStorage.removeItem('admin_ami_access');
}
